import { createSDKQueue } from '../../common/utils/create-sdk-queue';
import { loadCSMSDK } from '../../common/utils/load-js-sdk';
/**
 * Initialises the CSM SDK
 * Creates a queue to enable commands to be issued before the SDK is loaded
 *
 * If provided with a `widgetId`, the SDK once loaded will attempt to initialise the widget
 *
 * @returns Nothing for now, but maybe in future we'll return the SDK instance or just a
 * promise to be notified when it "loads"
 */
export var CSM = function CSM(_ref) {
  var site = _ref.site,
    siteId = _ref.siteId,
    widgetId = _ref.widgetId;
  if (typeof window === 'undefined') {
    return;
  }
  if (typeof window.CSM === 'undefined') {
    window.CSM = createSDKQueue();
  }
  loadCSMSDK({
    site: site,
    siteId: siteId,
    widgetId: widgetId
  });
};